import * as React from 'react';
type Props = {
  className?: string;
};
export function PencilAndPaper({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-PencilAndPaper"
      className={className}
    >
      <path
        d="M17.8666 2.66675H7.99992C7.29267 2.66675 6.6144 2.9477 6.1143 3.4478C5.6142 3.94789 5.33325 4.62617 5.33325 5.33341V26.6667C5.33325 27.374 5.6142 28.0523 6.1143 28.5524C6.6144 29.0525 7.29267 29.3334 7.99992 29.3334H23.9999C24.7072 29.3334 25.3854 29.0525 25.8855 28.5524C26.3856 28.0523 26.6666 27.374 26.6666 26.6667V16.8001"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66675 8H8.00008"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66675 13.3333H8.00008"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66675 18.6667H8.00008"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66675 24H8.00008"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.5039 7.50137C29.035 6.97023 29.3334 6.24985 29.3334 5.4987C29.3334 4.74756 29.035 4.02718 28.5039 3.49604C27.9727 2.9649 27.2524 2.6665 26.5012 2.6665C25.7501 2.6665 25.0297 2.9649 24.4986 3.49604L17.8186 10.1787C17.5016 10.4955 17.2695 10.8871 17.1439 11.3174L16.0279 15.144C15.9944 15.2588 15.9924 15.3804 16.0221 15.4962C16.0517 15.6119 16.112 15.7176 16.1965 15.8021C16.281 15.8866 16.3867 15.9469 16.5024 15.9765C16.6182 16.0062 16.7398 16.0042 16.8546 15.9707L20.6812 14.8547C21.1114 14.7291 21.5031 14.497 21.8199 14.18L28.5039 7.50137Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
